import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";
import { DadosPessoais } from "../../../interfaces/entities/MeuCadastro/DadosPessoais";
import "./styles.css";

const PersonalData: React.FC<{ nome: string; dadosPessoais: DadosPessoais }> = ({ dadosPessoais, nome }) => {

  const { calculateTextStyle, textStyleAccessibility, contrastStyle, contrastBorderAccessibility } = useAccessibility();
  const font14Style = calculateTextStyle(14)

  return (
    <div className="registration-data-card-holder">
      <div className="registration-data-card" style={{...contrastBorderAccessibility, ...contrastStyle}}>
        <div className="registration-data-row">
          <span style={textStyleAccessibility} className="registration-data-title">Dados pessoais</span>
        </div>
        <div className="registration-data-row registration-data-row-secondary" style={{...contrastBorderAccessibility, ...contrastStyle}}>
          <span style={font14Style} className="registration-data-key">Nome civil</span>
          <span style={font14Style} className="registration-data-value">{nome}</span>
        </div>
        <div className="registration-data-row" style={{...contrastBorderAccessibility}}>
          <span style={font14Style} className="registration-data-key">Data de nascimento</span>
          <span style={font14Style} className="registration-data-value">{dadosPessoais.dtNasc}</span>
        </div>
        <div className="registration-data-row registration-data-row-secondary" style={{...contrastBorderAccessibility, ...contrastStyle}}>
          <span style={font14Style} className="registration-data-key">Estado civil</span>
          <span style={font14Style} className="registration-data-value">{dadosPessoais.estadoCivil}</span>
        </div>
        <div className="registration-data-row">
          <span style={font14Style} className="registration-data-key">Sexo</span>
          <span style={font14Style} className="registration-data-value">{dadosPessoais.sexo}</span>
        </div>
      </div>
    </div>
  )
}

export default PersonalData;